export enum DndCategoryCardFieldType {
  Name = 'Name',
  FrName = 'FrName',
  Image = 'Image',
  FrImage = 'FrImage',
  Link = 'Link',
  IsValid = 'IsValid',
  SubmitFormCallback = 'SubmitFormCallback',
  Sources = 'Sources',
}
